export default __webpack_public_path__ + "static/media/us-ga.c80b9eeb.svg";